import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import AlertBanner from "./components/AlertBanner";
import Home from "./pages/Home";
import PatesFraiches from "./pages/PatesFraiches";
import Fromages from "./pages/Fromages";
import Charcuteries from "./pages/Charcuteries";
import PlatsCuisines from "./pages/PlatsCuisines";
import Desserts from "./pages/Desserts";
import InfosPratiques from "./pages/InfosPratiques";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import RGPD from "./pages/RGPD";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/toaster";

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <>
      <ScrollToTop />
      {!isAdminPage && <AlertBanner />}
      {!isAdminPage && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pates-fraiches" element={<PatesFraiches />} />
        <Route path="/fromages" element={<Fromages />} />
        <Route path="/charcuteries" element={<Charcuteries />} />
        <Route path="/plats-cuisines" element={<PlatsCuisines />} />
        <Route path="/desserts" element={<Desserts />} />
        <Route path="/infos-pratiques" element={<InfosPratiques />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        <Route path="/rgpd" element={<RGPD />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      {!isAdminPage && <Footer />}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
